<template>
  <quiz-layout>
    <template #sidebar>
      <div class="sidebar__menu">
        <router-link class="menu__item" :to="`/lessons`">
          <div class="item__title">Lessons</div>
        </router-link>
        <router-link class="menu__item" :to="`/users`">
          <div class="item__title">Users</div>
        </router-link>
      </div>
    </template>
    <template>
      <div class="content__title__wrapper">
        <div class="content__title">
          Quiz Detail
        </div>
        <div class="content__title__action">
          <button v-b-modal="'addQuiz'">Add Quiz</button>
          <button v-b-modal="'editQuiz'">Edit Quiz</button>
        </div>
      </div>
      <div class="content__group">
        <div class="question-card"
             :key="`questionKey${index}`"
             v-for="(question, index) in questions">
          <div class="question">
            {{ index + 1 }}. {{question.questionText}}
          </div>
          <div class="answer-options">
            <div class="option-wrapper"
                 :key="`option${index}${optionIndex}`"
                 v-for="(option, optionIndex) in question.options">
<!--              <div>
                <input :type="type[question.type]"
                       v-model="question.selected"
                       :value="option"
                       :name="type[question.type] === 'radio' ? `question${index + 1}` : ''"
                       :id="`option${index}${optionIndex}`">
              </div>-->
              <div>
                <label :for="`option${index}${optionIndex}`">{{option}}</label>
              </div>
            </div>
            <div>
              <b>Answers:</b>
            </div>
            <div v-for="(answer, answerIndex) in question.solution"
                 :key="'solution' + answerIndex">
              <span>{{answer}}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <b-modal id="addQuiz">
      Add quiz modal
    </b-modal>
    <b-modal id="editQuiz">
      Edit quiz modal
    </b-modal>
  </quiz-layout>
</template>
<script>
import QuizLayout from "../layout/QuizLayout.vue";
import {QuizService} from "../data/services/quiz.service";
export default {
  components: { QuizLayout },
  data() {
    return {
      type: {
        single: 'radio',
        multiple: 'checkbox',
      },
      isLoading: true,
      questions: [],
    };
  },
  computed: {
    slug () {
      return this.$route.params.slug
    }
  },
  mounted() {
    this.getQuestions();
  },
  methods: {
    async getQuestions() {
      //
      const quizService = new QuizService();
      await quizService.getQuizQuestions(this.slug).then(response => {
        console.log('response', response)
        this.questions = response;
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  &__title__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__title__action {
    button {
      background: transparent;
      border: none;
      color: #024089;

      &:first-child {
        margin-right: 15px;
      }
    }
  }
  &__title {
    font-weight: 500;
    font-size: 22px;
    line-height: 25px;
    margin-bottom: 12px;
  }
  &__group {
    padding: 20px;
    width: 100%;
    //background: white;
    display: flex;
    flex-direction: column;
    border-radius: 10px;


    .question-card {
      margin-bottom: 26px;
      padding: 20px 26px;
      background: #FFFFFF;
      border-radius: 20px;

      .question {
        margin-bottom: 12px;
      }
      .answer-options {
        padding-left: 18px;

        .option-wrapper {
          margin-bottom: 4px;
          display: flex;
          //gap: 4px;

          input {
            margin: 0;
          }
          label {
            margin: 0;
            margin-left: 12px;
          }
        }
      }
    }
  }
}
.group {
  &__item {
    display: flex;
    align-content: center;
    justify-content: space-between;
    + .group__item {
      margin-top: 10px;
    }
  }
  &__title {
    font-size: 16px;
    align-self: center;
  }
  &__action {
    cursor: pointer;
    font-size: 14px;
    padding: 4px 15px;
    background: #f1bc04;
    color: #ffffff;
    border-radius: 20px;
  }
}

.sidebar {
  &__menu {
    display: flex;
    flex-direction: column;
  }
}

.menu {
  &__item {
    display: flex;
    cursor: pointer;
    align-items: center;
    + .menu__item {
      margin-top: 10px;
    }
  }
}

.item {
  &__icon {
    width: 26px;
    margin-right: 15px;
    svg {
      width: 100%;
    }
  }
  &__title {
    color: #ffffff;
    font-size: 20px;
    line-height: 24px;
    &:hover {
      color: #f1bc04;
    }
  }
}
</style>
